<div>There is already a Miscellaneous Income request with the selected income type, reason, currency, cost centre, company, brokerage period and/or business unit.</div>
<div>Would you like to proceed?</div>
<div class="snackBarbuttons">
    <button id="button-confirm"(click)="confirmCreatingMisscelaneousIncome()">Proceed</button>
    <button id="button-cancel" (click)="snackBarRef.dismiss()">Cancel</button>
</div>